// extracted by mini-css-extract-plugin
module.exports = {"modal-dialog":"s_b1","modalDialog":"s_b1","modal-title":"s_b2","modalTitle":"s_b2","modal-subtitle":"s_b3","modalSubtitle":"s_b3"};